// removed by extract-text-webpack-plugin
module.exports = {"resume":"Resume__resume__2b9xU","button_col":"Resume__button_col__HHUsI","button":"Resume__button__1xcEU"};


//////////////////
// WEBPACK FOOTER
// ./src/Components/Resume/Resume.css
// module id = 43
// module chunks = 0